import { ComponentType, LazyExoticComponent, ReactNode, lazy } from "react";
import GAnalytics from "../assets/GAnalytics.png";
import Miro from "../assets/Miro.png";
import OneC from "../assets/1C.png";
import Bitrix from "../assets/Bitrix.png";
import Sketch from "../assets/sketch.png";
import Ios from "../assets/ios.png";
import Apple from "../assets/apple.png";
import Swift from "../assets/swift.png";
import Android from "../assets/android.png";
import AndroidStudio from "../assets/androidStudio.png";
import AndroidSdk from "../assets/androidSdk.png";
import MVC from "../assets/MVC.png";
import ReactIcon from "../assets/react.png";
import Next from "../assets/next.png";
import Nest from "../assets/nest.png";
import Angular from "../assets/angular.png";
import Django from "../assets/django.png";
import Fastapi from "../assets/fastapi.png";
import Node from "../assets/node.png";
import Js from "../assets/js.png";
import PM2 from "../assets/PM2.png";
import Nginx from "../assets/nginx.png";
import Kuber from "../assets/kuber.png";
import Docker from "../assets/docker.png";
import Postman from "../assets/postman.png";
import Gitlab from "../assets/gitlab.png";
import Cloud from "../assets/cloud.png";
import Appium from "../assets/appium.png";
import Selenium from "../assets/selenium.png";
import Jest from "../assets/jest.png";
import Mocha from "../assets/mocha.png";
import Sql from "../assets/sql.png";
import { GoodImage } from "./styles";

const Adobe = lazy(() => import("../assets/Adobe"));
const Protopie = lazy(() => import("../assets/Protopie"));
const UT = lazy(() => import("../assets/UT"));
const API = lazy(() => import("../assets/API"));
const CICD = lazy(() => import("../assets/CICD"));
const AB = lazy(() => import("../assets/AB"));
const SAP = lazy(() => import("../assets/SAP"));
const CRM = lazy(() => import("../assets/CRM"));
const Figma = lazy(() => import("../assets/Figma"));
const Pillars = lazy(() => import("../assets/Pillars"));
const Laptop = lazy(() => import("../assets/Laptop"));
const PencilScreen = lazy(() => import("../assets/PencilScreen"));
const Phones = lazy(() => import("../assets/Phones"));
const Controller = lazy(() => import("../assets/Controller"));
const Server = lazy(() => import("../assets/Server"));
const Magnifier = lazy(() => import("../assets/Magnifier"));
const CastDev = lazy(() => import("../assets/CastDev"));
const AT = lazy(() => import("../assets/AT"));

export interface DevelopmentDataType {
  title: ReactNode;
  desc: string;
  MainLogo?: (() => JSX.Element) | (LazyExoticComponent<ComponentType<any>>);
  additionalData: {
    title: string;
    miniTitle: string;
    desc: string;
  }[];
  tags: ReactNode[];
}

export const developmentData: DevelopmentDataType[] = [
  {
    title: "Продуктовая аналитика",
    MainLogo: Pillars,
    desc: "Помогаем понимать поведение пользователей, выявлять ключевые метрики, оптимизировать продуктовые решения и принимать обоснованные стратегические решения.",
    additionalData: [
      {
        title: "Анализ начальных требований",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Рабочие встречи",
        miniTitle: "2-3 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Анализ конкурентов",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
    ],
    tags: [
      "От 2 дней",
      <>
        <GoodImage height="20" src={require("../../content/assets/YMetric.png")} alt="Yandex Metrics" />
        <>Яндекс.Метрика</>
      </>,
      <>
        <GoodImage height="20" src={GAnalytics} alt="Google Analytics" />
        <>Google Analytics</>
      </>,
      <>
        <AB />
        A/B Testing
      </>,
      "Маркетплейсы",
      <>
        <CastDev />
        CastDev
      </>,
    ],
  },
  {
    title: "Бизнес-аналитика",
    MainLogo: Laptop,
    desc: "Анализируем бизнес-процессы, выявляем важные тренды и паттерны, а также предоставляем ценные инсайты для принятия стратегических решений.",
    additionalData: [
      {
        title: "Анализ начальных требований",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Рабочие встречи",
        miniTitle: "2-3 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Анализ конкурентов",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
    ],
    tags: [
      "От 2 дней",
      <>
        <>SAP</>
        <SAP />
      </>,
      <>
        <CRM />
        <>CRM</>
      </>,
      <>
        <GoodImage height="20" src={Miro} alt="Miro" />
        <>Miro</>
      </>,
      <>
        <Figma />
        <>FigJam</>
      </>,
      <>
        <GoodImage height="20" src={OneC} alt="1C" />
        <>1C</>
      </>,
      <>
        <GoodImage height="20" src={Bitrix} alt="Bitrix" />
        <>Bitrix</>
      </>,
    ],
  },
  {
    title: (
      <>
        <>UI/UX</>
        <br/>
        <>Design</>
      </>
    ),
    MainLogo: PencilScreen,
    desc: "Разрабатываем интуитивно понятные и привлекательные интерфейсы, улучшая взаимодействие пользователей с продуктом.",
    additionalData: [
      {
        title: "Анализ начальных требований",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Рабочие встречи",
        miniTitle: "2-3 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Анализ конкурентов",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
    ],
    tags: [
      "от 5 дней",
      <>
        <Figma />
        <>FigJam</>
      </>,
      <>
        <GoodImage height="20" src={Sketch} alt="Sketch" />
        <>Sketch</>
      </>,
      <>
        <Adobe />
        <>Adobe</>
      </>,
      <>
        <Protopie />
        <>Protopie</>
      </>,
    ],
  },
  {
    title: "Мобильная разработка",
    MainLogo: Phones,
    desc: "Создаем и оптимизируем мобильные приложений для различных платформ, таких как iOS и Android, с последующей поддержкой и обновлением приложений.",
    additionalData: [
      {
        title: "Анализ начальных требований",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Рабочие встречи",
        miniTitle: "2-3 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Анализ конкурентов",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
    ],
    tags: [
      "От 5 дней",
      <>
        <GoodImage height="20" src={Ios} alt="Ios" />
        <>iOS</>
      </>,
      <>
        <GoodImage height="20" src={Apple} alt="Apple" />
        <>Apple SDK</>
      </>,
      <>
        <GoodImage height="20" src={Swift} alt="Swift" />
        <>Swift SDK</>
      </>,
      <>
        <GoodImage height="20" src={Android} alt="Android" />
        <>Android</>
      </>,
      <>
        <GoodImage height="20" src={AndroidStudio} alt="AndroidStudio" />
        <>Android Studio</>
      </>,
      <>
        <GoodImage height="20" src={AndroidSdk} alt="AndroidSdk" />
        <>Android SDK</>
      </>,
      <>
        <GoodImage height="20" src={MVC} alt="MVC" />
        <>MVC</>
      </>,
      <>
        <UT />
        <>Unit Testing</>
      </>,
    ],
  },
  {
    title: "Веб-разработка",
    MainLogo: Controller,
    desc: "Помогаем организациям создавать, модернизировать и поддерживать веб-сайты, обеспечивая их функциональность, производительность и безопасность.",
    additionalData: [
      {
        title: "Анализ начальных требований",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Рабочие встречи",
        miniTitle: "2-3 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Анализ конкурентов",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
    ],
    tags: [
      "От 5 дней",
      <>
        <GoodImage height="20" src={ReactIcon} alt="React" />
        <>React</>
      </>,
      <>
        <GoodImage height="20" src={Next} alt="Next" />
        <>Next</>
      </>,
      <>
        <GoodImage height="20" src={Nest} alt="Nest" />
        <>Nest</>
      </>,
      <>
        <GoodImage height="20" src={Angular} alt="Angular" />
        <>Angular</>
      </>,
      <>
        <GoodImage height="20" src={Django} alt="Django" />
        <>Django</>
      </>,
      <>
        <GoodImage height="20" src={Fastapi} alt="Fastapi" />
        <>Fastapi</>
      </>,
      <>
        <GoodImage height="20" src={Node} alt="Node" />
        <>Node</>
      </>,
      <>
        <GoodImage height="20" src={Js} alt="Js" />
        <>JavaScript</>
      </>,
      <>
        <GoodImage height="20" src={PM2} alt="PM2" />
        <>PM2</>
      </>,
      <>
        <GoodImage height="20" src={Nginx} alt="Nginx" />
        <>Nginx</>
      </>,
    ],
  },
  {
    title: <>
    <>DevOps</>
    <br/>
    <>и SRE</>
  </>,
    MainLogo: Server,
    desc: "Помогаем организациям оптимизировать и автоматизировать процессы разработки и эксплуатации программного обеспечения.",
    additionalData: [
      {
        title: "Анализ начальных требований",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Рабочие встречи",
        miniTitle: "2-3 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Анализ конкурентов",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
    ],
    tags: [
      "От 5 дней",
      <>
        <CICD />
        <>CI/CD</>
      </>,
      <>
        <GoodImage height="20" src={Kuber} alt="Kuber" />
        <>Kubernetes</>
      </>,
      <>
        <GoodImage height="20" src={Docker} alt="Docker" />
        <>Docker</>
      </>,
      <>
        <GoodImage height="20" src={Gitlab} alt="Gitlab" />
        <>GitLab</>
      </>,
      <>
        <GoodImage height="20" src={Cloud} alt="YCloud" />
        <>Yandex Cloud</>
      </>,
    ],
  },
  {
    title: "Тестирование и поддержка",
    MainLogo: Magnifier,
    desc: "Разрабатываем стратегии, создаем тест-планы и тест-кейсы, выполняем тестирование, включая автоматизацию, и предоставляем отчеты с рекомендациями для улучшения качества продукта.",
    additionalData: [
      {
        title: "Анализ начальных требований",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Рабочие встречи",
        miniTitle: "2-3 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
      {
        title: "Анализ конкурентов",
        miniTitle: "1-2 дня",
        desc: "Наши бизнес-аналитик и дизайнер собирают функциональные и нефункциональные требования, описывают сценарии пользователей, проводят пользовательские интервью, создают прототипы интерфейса.",
      },
    ],
    tags: [
      "От 5 дней",
      <>
        <GoodImage height="20" src={Cloud} alt="Postman" />
        <>Yandex Cloud</>
      </>,
      <>
        <GoodImage height="20" src={Appium} alt="Appium" />
        <>Appium</>
      </>,
      <>
        <GoodImage height="20" src={Selenium} alt="Selenium" />
        <>Selenium</>
      </>,
      <>
        <GoodImage height="20" src={Jest} alt="Jest" />
        <>Jest</>
      </>,
      <>
        <GoodImage height="20" src={Mocha} alt="Mocha" />
        <>Mocha</>
      </>,
      <>
        <GoodImage height="20" src={Sql} alt="Sql" />
        <>SQL</>
      </>,
      <>
        <API />
        <>API</>
      </>,
      <>
        <AT />
        <>Автотест</>
      </>,
    ],
  },
];

export const textData = {
  title: "Наши услуги",
  ctaTitle: "Хотите узнать точную цену и сроки?",
  ctaText: "Пришлите нам описание проекта или свяжитесь напрямую",
  buttons: [
    "Заполнить форму связи",
    "Телеграм",
    "hello@ap.com",
    "+7 912 345-6789",
  ],
  count: "Рассчитать стоимость проекта",
};
